/**
 * Navigation post-conversion SERVICE → Prestation (micro-fix UX).
 * Pure helpers — pas de React / pas d’API.
 */

/**
 * Extrait l’id Prestation de la réponse POST /prestations
 * (création 201 ou alreadyConverted 200).
 * @param {unknown} response
 * @returns {string|null}
 */
export function extractPrestationIdFromCreateResponse(response) {
  if (!response || typeof response !== 'object') return null;
  const id = response.prestation?.id || response.id || null;
  if (typeof id !== 'string' || !id.trim()) return null;
  return id.trim();
}

/**
 * Décide si on doit ouvrir la Prestation après conversion.
 * @param {{ response?: unknown, createSucceeded: boolean }} input
 * @returns {{ prestationId: string, alreadyConverted: boolean }|null}
 */
export function resolvePostConversionEditTarget({ response, createSucceeded } = {}) {
  if (!createSucceeded) return null;
  const prestationId = extractPrestationIdFromCreateResponse(response);
  if (!prestationId) return null;
  return {
    prestationId,
    alreadyConverted: Boolean(response?.alreadyConverted),
  };
}

/**
 * Consomme `_convertedPrestationId` issu du onSave ProduitModal.
 * Appelle onRequestEditPrestation exactement 1× si id présent.
 * @returns {boolean} true si navigation demandée
 */
export function consumeConvertedPrestationFromSave(savedProduit, onRequestEditPrestation) {
  const id =
    typeof savedProduit?._convertedPrestationId === 'string'
      ? savedProduit._convertedPrestationId.trim()
      : '';
  if (!id) return false;
  if (typeof onRequestEditPrestation !== 'function') return false;
  onRequestEditPrestation(id);
  return true;
}
